module.exports = __webpack_public_path__ + "85dca1ee6157bb1773fa31369d320778.svg";